$(window).on('load', function() {
  // Product Cards
  $(".product-list .image-cont").each(function() {
    var videoElement = $(this).find('video').get(0);

    // Check if a video element is present
    if (videoElement) {
      $(this).hover(
          function() {
            // Mouseover event
            videoElement.play();
          },
          function() {
            // Mouseout event
            videoElement.pause();
          }
      );
    }
  });

  // accordion
  // var acc = document.getElementsByClassName("accordion");
  // var i;
  //
  // for (i = 0; i < acc.length; i++) {
  //   acc[i].addEventListener("click", function() {
  //     this.classList.toggle("active");
  //     var panel = this.nextElementSibling;
  //     if (panel.style.maxHeight){
  //       panel.style.maxHeight = null;
  //     } else {
  //       panel.style.maxHeight = panel.scrollHeight + "px";
  //     }
  //   });
  // }

  $('.shopify-currency-form select').on('change', function() {
    $(this).parents('form').submit();
  });

  // ACCORDION INFO
  //
  // loop through each list item
  // $('.rte li').each(function(index, item) {
  //
  //   // finds and adds title
  //   var _ = $(this);
  //   var title = _.find('strong:first-child, b:first-child').text();
  //   _.find('strong:first-child, b:first-child').remove();
  //   //var content = _.html().replace(title, '').trim();
  //   var content = _.html().trim();
  //
  //   // set the data to the DOM element (tag)
  //   _.data('content', content);
  //   _.data('title', title);
  //
  //   _.html('<strong>'+title+'</strong><div>'+content+'</div>');
  //
  // });

  // on click
  $('table').on('click', function() {

    var _ = $(this);
    if(!_.hasClass('isOpen')) {
      _.siblings('.isOpen').removeClass('isOpen');
      _.addClass('isOpen');
    } else {
      _.removeClass('isOpen');
    }

  });

  $('.navigation__children-toggle-2').click(function() {
    $('.navigation__item').toggleClass('menuOpen');
  });

});

// target blank script
var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }

// Tooltip code, attach a tooltip attritube to a HTML element for a tooltip to appear. e.g. <p tooltip="Tooltip Content">Normal Content</p>
document.addEventListener('DOMContentLoaded', function () {
  var tooltipDiv = document.createElement('div');
  tooltipDiv.className = 'custom-tooltip';
  document.body.appendChild(tooltipDiv);

  function showTooltip(element) {
    tooltipDiv.innerHTML = element.getAttribute('tooltip');
    tooltipDiv.style.display = 'block';

    var rect = element.getBoundingClientRect();
    var arrowHeight = 2.5; // Height of the arrow

    // Center tooltip horizontally
    tooltipDiv.style.left = rect.left + (element.offsetWidth / 2) - (tooltipDiv.offsetWidth / 2) + 'px';

    // Position tooltip below the element, considering arrow height
    tooltipDiv.style.top = window.scrollY + rect.bottom + arrowHeight + 'px';
  }

  function hideTooltip() {
    tooltipDiv.style.display = 'none';
  }

  var elements = document.querySelectorAll('[tooltip]');
  elements.forEach(function (element) {
    element.addEventListener('mouseenter', function () {
      showTooltip(element);
    });
    element.addEventListener('mouseleave', hideTooltip);
  });
});
